import PropertyList from "components/folder/property-list/property-list"
export default PropertyList

import PropertyList_s from "components/folder/property-list/property-list-styles"
export { PropertyList_s }
